// extracted by mini-css-extract-plugin
export var bgIndex = "index-module--bgIndex--dsmLh";
export var centering = "index-module--centering--1Ys-U";
export var image = "index-module--image--D+Msn";
export var typing = "index-module--typing--OU-KD";